import { all, call, put, select, takeLatest } from "redux-saga/effects";
import {
  getDetailRecruitmentFailed,
  getDetailRecruitmentStart,
  getDetailRecruitmentSuccess,
} from "../redux/getDetailRecruitment";
import { getRecruitmentRequirementDetailApi } from "core/http/service/recruitment";

import { toast } from "react-toastify";
import { formRecruitmentUpdate, updateSteps } from "../redux/formInput";
import { stepsSelector } from "../redux/selector";
import moment from "moment";
import { ApproveStatusValue } from "modules/DeclareLeave/components/CustomCalendarTimeKeeping/const";

function* getDetailRecruitmentWork(action) {
  const id = action.payload;
  const stepsDefault = yield select(stepsSelector);

  try {
    const res = yield call(getRecruitmentRequirementDetailApi, id);
    const relatePersonNames = (res?.relatePersonName ?? "").split(",");
    const relatePerson = (res?.relatePerson || "")
      .split(",")
      .map((item, index) => ({
        label: (relatePersonNames[index] || "").replace(",", "").trim() || "",
        value: item.replace(",", "").trim(),
      }));
    const newData = {
      ...res,
      files: res?.filePath ? JSON.parse(res?.filePath || "") : [],
      quantityRequest: res?.quantityRequest ? String(res?.quantityRequest) : "",
      minAge: res?.minAge ? String(res?.minAge) : "",
      maxAge: res?.maxAge ? String(res?.maxAge) : "",
      specializedCode: res?.specializedCodes || [],
      practiceCertificateCode: res?.practiceCertificateCodes || [],
      languageLevelCode: res?.languageLevelCodes || [],
      specializedNames: (res?.specializedCodes || [])
        ?.map((it) => it?.label)
        ?.join(", "),
      languageLevelNames: (res?.languageLevelCodes || [])
        ?.map((it) => it?.label)
        ?.join(", "),
      practiceCertificateNames: (res?.practiceCertificateCodes || [])
        ?.map((it) => it?.label)
        ?.join(", "),
      relatePerson,
    };
    const formatDate = (date) =>
      date ? moment(date).format("DD/MM/YYYY") : null;

    const newSteps = [
      {
        ...stepsDefault[0],
        updateAt: formatDate(res?.requestDate),
        updateBy: res?.requesterName,
      },
      {
        ...stepsDefault[1],
        updateAt: formatDate(res?.mngApproveDate),
        updateBy: res?.mngApproverName,
        status: res?.mngApproveStatus,
        label:
          res?.mngApproveStatus === ApproveStatusValue.APPROVE
            ? "CBQL phê duyệt"
            : res?.mngApproveStatus === ApproveStatusValue.REFUSE
              ? "CBQL từ chối"
              : "CBQL chờ duyệt",
      },
      {
        ...stepsDefault[2],
        updateAt: formatDate(res?.hrmApproveDate),
        updateBy: res?.hrmApproverName,
        status: res?.hrmApproveStatus,
        label:
          res?.hrmApproveStatus === ApproveStatusValue.APPROVE
            ? "HR phê duyệt"
            : res?.hrmApproveStatus === ApproveStatusValue.REFUSE
              ? "HR từ chối"
              : "HR chờ duyệt",
      },
    ];

    yield put({
      type: updateSteps.type,
      payload: newSteps,
    });
    yield put({
      type: getDetailRecruitmentSuccess.type,
    });
    yield put({
      type: formRecruitmentUpdate.type,
      payload: newData,
    });
  } catch (error) {
    yield put({
      type: getDetailRecruitmentFailed.type,
    });
    toast.error(error?.response?.data?.message || "Đã có lỗi xảy ra!");
  }
}

function* watchGetDetailRecruitment() {
  yield takeLatest(getDetailRecruitmentStart.type, getDetailRecruitmentWork);
}

export default function* getDetailRecruitmentSaga() {
  yield all([watchGetDetailRecruitment()]);
}
